<template>
    <div class="page">
        <van-cell title="选择单个日期" :value="date" @click="show()" />
        <van-calendar
            v-model="visible"
            @confirm="onConfirm"
            :min-date="minDate"
            :max-date="maxDate"
            :default-date="defaultDate"
        />
        <div class="box">
            <div class="title">机构龙虎榜</div>
            <div class="row">
                <table>
                    <thead>
                        <tr>
                            <th colspan="3">机构净买入</th>
                        </tr>
                        <tr>
                            <th>公司名称</th>
                            <th>涨跌幅</th>
                            <th>
                                金额
                                <br />
                                (万元)
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in jigouQ5" :key="item.SCode">
                            <td>{{ item.SName }}</td>
                            <td>{{ item.Chgradio }}</td>
                            <td>{{ item.PBuy }}</td>
                        </tr>
                    </tbody>
                </table>
                <table>
                    <thead>
                        <tr>
                            <th colspan="3">机构净卖出</th>
                        </tr>
                        <tr>
                            <th>公司名称</th>
                            <th>涨跌幅</th>
                            <th>
                                金额
                                <br />
                                (万元)
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in jigouH5" :key="item.SCode">
                            <td>{{ item.SName }}</td>
                            <td>{{ item.Chgradio }}</td>
                            <td>{{ item.PBuy }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="box">
            <div class="title">北向资金龙虎榜</div>
            <div class="row">
                <table>
                    <thead>
                        <tr>
                            <th colspan="3">沪股通资金流向</th>
                        </tr>
                        <tr>
                            <th>公司名称</th>
                            <th>涨跌幅</th>
                            <th>
                                金额
                                <br />
                                (万元)
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in hgt" :key="item.SCode">
                            <td>{{ item.SName }}</td>
                            <td>{{ item.Chgradio }}</td>
                            <td>{{ item.PBuy }}</td>
                        </tr>
                    </tbody>
                </table>
                <table>
                    <thead>
                        <tr>
                            <th colspan="3">深股通资金流向</th>
                        </tr>
                        <tr>
                            <th>公司名称</th>
                            <th>涨跌幅</th>
                            <th>
                                金额
                                <br />
                                (万元)
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in sgt" :key="item.SCode">
                            <td>{{ item.SName }}</td>
                            <td>{{ item.Chgradio }}</td>
                            <td>{{ item.PBuy }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="box">
            <div class="title">北向资金</div>
            <div class="row">
                <table>
                    <thead>
                        <tr>
                            <th colspan="3">沪股通净买入TOP10</th>
                        </tr>
                        <tr>
                            <th>公司名称</th>
                            <th>涨跌幅</th>
                            <th>
                                金额
                                <br />
                                (万元)
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in hgtLr" :key="item.SCode">
                            <td>{{ item.sec_name }}</td>
                            <td>{{ item.pct_chg }}</td>
                            <td>{{ item.mfd_sn_inflow }}</td>
                        </tr>
                    </tbody>
                </table>
                <table>
                    <thead>
                        <tr>
                            <th colspan="3">深股通净买入TOP10</th>
                        </tr>
                        <tr>
                            <th>公司名称</th>
                            <th>涨跌幅</th>
                            <th>
                                金额
                                <br />
                                (万元)
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in sgtJe" :key="item.SCode">
                            <td>{{ item.sec_name }}</td>
                            <td>{{ item.pct_chg }}</td>
                            <td>{{ item.mfd_sn_inflow }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped src="./data-template.scss">
</style>

<script>
import dataTemplateService from "../../service/data-template.service";
export default {
    name: "data-template",
    data() {
        return {
            jigouQ5: [],
            jigouH5: [],
            hgt: [],
            sgt: [],
            hgtLr: [],
            sgtJe: [],
            visible: false,
            date: "",
            minDate: new Date(2020, 0, 1),
            maxDate: new Date(Date.now()),
            defaultDate: new Date(Date.now())
        };
    },
    created() {
        this.init(this.formatDate(Date.now()));
    },
    methods: {
        init(date) {
            dataTemplateService.getJigou(date).then(res => {
                this.jigouQ5 = res.data.jigouQ5;
                this.jigouH5 = res.data.jigouH5;
                this.hgt = res.data.hgt;
                this.sgt = res.data.sgt;
                this.hgtLr = res.data.hgtLr;
                this.sgtJe = res.data.sgtJe;
            });
        },
        formatDate(date) {
            let y = new Date(date).getFullYear();
            let m = new Date(date).getMonth() + 1;
            let d = new Date(date).getDate();
            if (m < 10) {
                m = "0" + m;
            }
            if (d < 10) {
                d = "0" + d;
            }
            return `${y}-${m}-${d}`;
        },
        show() {
            this.visible = true;
        },
        onConfirm(date) {
            this.date = this.formatDate(date);
            this.visible = false;
            this.init(this.date);
        }
    }
};
</script>